module.exports = __webpack_public_path__ + "img/experience11.051cba85.png";